import {MRT_Column} from "material-react-table";
import {AonColors, textStyle} from "../../../../css/Colors";
import {TableCellProps} from "@mui/material";

// TODO - replace any by generic type
export const headersStyle = (column: MRT_Column<any>) => {
    const borderRight = column.getIsLastColumn() ? "0" : `1px solid ${AonColors.AonGray05}`;
    const isColumnFiltered = column.getFilterValue() && (column.getFilterValue() as []).length > 0;
    return {
        ...textStyle("700", "14px", "18px", AonColors.AonNavy, "12px"),
        borderTop: "0",
        borderRight,
        "& .Mui-TableHeadCell-Content-Labels svg": {
            color: isColumnFiltered ? AonColors.AonTealDark : AonColors.AonGray01,
            fontWeight: isColumnFiltered ? "700" : "400",
        },
    };
};

export const MrtTableStyle: TableCellProps['sx'] = {
    borderWidth: "1px 1px 0 1px",
    borderColor: AonColors.AonGray05,
    borderStyle: "solid",
    borderSpacing: "0",
};

export const bottomToolbarStyle: TableCellProps['sx'] = {
    borderWidth: "0 1px 1px 1px",
    borderColor: AonColors.AonGray05,
    borderStyle: "solid",
    boxShadow: "none",
    "& .MuiTablePagination-root":{marginBottom: "16px"},
    "& .MuiTablePagination-root svg": textStyle("400", "16px", "20px", AonColors.AonGray02, "0"),
    "& .MuiButtonBase-root": {'&:hover': { backgroundColor: AonColors.AonGray07}},
    "& .MuiInputBase-input": {paddingBottom: 0},
    "& .MuiTypography-root": textStyle("400", "16px", "20px", AonColors.AonGray02, "0"),
    "& .MuiInputBase-root": textStyle("400", "16px", "20px", AonColors.AonGray02, "0"),
    "& .MuiInputLabel-root": textStyle("400", "16px", "20px", AonColors.AonGray02, "0"),
};

export const topToolbarStyle: TableCellProps['sx'] = {
    "& .MuiInputBase-input": {
        color: `${AonColors.AonGray02}`,
        paddingLeft: "8px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
        border: `1px solid ${AonColors.AonGray01}`,
        borderRadius: "4px",
        backgroundColor: "none"
    },
    "& .Mui-focused": {
        "& .MuiOutlinedInput-notchedOutline": {
            border: `2px solid ${AonColors.AonSearchTealDarkHover} !important`,
            borderRadius: "4px",
            backgroundColor: "none"
        },
    },
};

export const filterTextFieldStyle: TableCellProps['sx'] = {
    // "& .MuiInput-root::before": {
    //     borderBottom: `1px solid ${AonColors.AonErrorRed}`,
    // },
    "& .MuiInput-root::after": {
        borderBottom: `2px solid ${AonColors.AonSearchTealDarkHover}`,
    },
    "& .MuiInputBase-input": {
        color: `${AonColors.AonGray02}`,
        fontFamily: `"Helvetica Now Text", "sans-serif"`,
    },
};
